import { Provider } from '@angular/core';

import { NgEventBus } from 'ng-event-bus';

import { FzEventBus } from '@fantaz/shared/domain';

import { TypedNgEventBus } from './ws';

export function provideEventBus(): Provider {
  return [
    NgEventBus,
    {
      provide: FzEventBus,
      useClass: TypedNgEventBus,
      deps: [NgEventBus],
    },
  ];
}
